import React, {useState, Fragment, useEffect} from 'react'
import styled from '@emotion/styled';
import pocketLogoImage from './pocket-logo.svg';
import magnifyingGlassImage from './magnifying-glass.svg';
import magnifyingGlassImageMobile from './magnifying-glass--mobile.svg';
import closeImage from './close.svg';
import arrowImage from './arrow.svg';
import menuItems from './menuItems';
import {subNav, myList} from './menuItems';

// TODO, move these constants to a proper home
const FONT_GRAPHIK = `"Graphik Web", "Helvetica Neue", Helvetica, Arial, sans-serif`;

const colorGray20 = '#D3D3D3';
const colorGray60 = '#919191';
const colorGray80 = '#505050';
const colorGray100 = '#1a1a1a';
const colorPine80 = '#007A73';

const XXS = 320;
const XS = 374;
const SM = 700;
const SMD = 912;
const MD = 1110;
const LG = 1234;
const HEADER_MAX_WIDTH = 1530;

const breakpoints = [{
  label: 'XXS',
  width: XXS,
}, {
  label: 'XS',
  width: XS,
}, {
  label: 'SM',
  width: SM,
}, {}, {
  label: 'SMD',
  width: SMD,
}, {
  label: 'MD',
  width: MD,
}, {
  label: 'LG',
  width: LG,
}];

// xxl is broken out to its own media query line because it used min-width
const mq = breakpoints.reduce((acc, bp) => ({...acc, [bp.label]: `@media (max-width: ${bp.width}px)`}), {});
const xxl = `@media (min-width: ${HEADER_MAX_WIDTH}px)`;

const PocketLogo = styled.span`
    background-image: url(${pocketLogoImage});
    background-repeat: no-repeat;
    display: block;
    width: 90px;
    height: 24px;
    margin-left: 10px;
    margin-top: 3px;

    ${mq['SM']} {
      margin-top: 2px;
      margin-left: 20px;
      width: 95px;
      height: 25px;
    }
`

const NoopAnchor = (props) => (
    <a {...props} onClick={(e) => {
      e.preventDefault();
      props.onClick();
      return false;
    }}>{props.children}</a>
)

const NavItemLink = styled(NoopAnchor)`
    &:hover {
      color: ${colorPine80} !important;
    }
    color: ${colorGray80} !important;
    text-decoration: none;
    padding: 5px 8px;
    margin: 0 8px;
    font-size: 14px;

    ${mq['SMD']} {
      margin: 0 6px;
    }

    ${mq['SM']} {
      padding: 5px 2px;

      margin: 0;
      padding: 0;
    }
`

const NavItemLinkSelected = styled(NavItemLink)`
  color: ${colorGray100};
  font-weight: 600;
  pointer-events: none;

  &:hover {
    color: ${colorGray80} !important;
  }
`

const NavItem = styled.li`
  padding: 0;
  list-style-type: none;
  display: inline-block;
  white-space: nowrap;

  // breakpoints below are for bucketing nav items at different widths
  ${mq['LG']} {
    &.nav-item-7,
    &.nav-item-6 {
      display: none;
    }
  }

  ${mq['MD']} {
    &.nav-item-5,
    &.nav-item-4 {
      display: none;
    }
  }

  ${mq['SMD']} {
    &.nav-item-3,
    &.nav-item-2 {
      display: none;
    }
  }

  ${mq['SM']} {
    &.nav-item-0,
    &.nav-item-1,
    &.nav-item-2 {
      display: inline-block;
    }
  }

  ${mq['XS']} {
    &.nav-item-2 {
      display: none;
    }
  }

  ${mq['XXS']} {
    &.nav-item-2 {
      display: none;
    }
  }


  ${xxl} {
    &:first-of-type {
      a {
      margin-left: 0;
      padding-left: 0;
      }
    }
  }
`

const NavList = styled.ul`
    margin: 0 0 0 16px;
    padding: 0;
    display: inline-block;
    flex: 0 0 auto;

    ${mq['SM']} {
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex: 1;
      margin: 0 0 0 20px;
      padding: 0;
    }
`

const NavContainer = styled.div`
    padding: 0;

    ${mq['SM']} {
      display: flex;
      order: 3;
      border-top: solid 1px ${colorGray20};
      margin-left: 0;
      flex: 3;
      flex-basis: 70%;
      flex-grow: 0;
      font-size: 14px;
      box-sizing: content-box;
      height: 46px;
      align-items: center;
    }

    ${mq['XS']} {
      flex-basis: 60%;
    }

    ${xxl} {
      padding: 0 0 0 100px;
    }
`

const ExploreHeader = styled.div`
    display: flex; align-items: center;
    max-width: ${HEADER_MAX_WIDTH}px;
    height: 60px;
    font-family: ${FONT_GRAPHIK};
    padding: 0 32px;
    margin: 0 auto;
    min-width: 320px;
    line-height: 1;
    ${mq['SM']} {
      flex-wrap: wrap;
      height: 94px;
      padding: 0;
      border-bottom: none;
    }
`

const ExploreContainer = styled.div`
  border-bottom: solid 1px ${colorGray20};
  background-color: #ffffff;
  position: sticky;
  top: 0;
`

const SearchContainer = styled.div`
  margin-left: 30px;
  justify-content: flex-end;
  display: flex;

  ${mq['SM']} {
    order: 2;
    padding-right: 20px;
    flex: 0 0 auto;
    margin-left: 6px;
    position: relative;
  }
`

const DesktopSearchBar = styled.div`
  position: relative;

  ${mq['SM']} {
    display: none;
  }
`

const SearchInput = styled.input`
    color: #444;
    font-size: 12px;
    line-height: 20px;
    border-radius: 5px;
    border: 1px solid #ddd;
    outline: none;
    padding: 3px 10px 4px 30px;
    transition: width .15s ease-in-out;
    width: 136px;
    &:focus {
      width: 12rem;
    }

    ${mq['SM']} {
      &:focus {
        width: 10rem;
      }
    }
`

const MobileSearchInput = styled(SearchInput)`
  flex: 1;
  height: 35px;
  font-size: 14px;
  padding: 0 0 0 35px;
`

const SearchIcon = styled.div`
    mask-image: url(${magnifyingGlassImage});
    mask-repeat: no-repeat;
    width: 14px;
    height: 14px;
    background-color: #828282;
    position: absolute;
    top: 7px;
    left: 9px;
`

const SearchIconInput = styled(SearchIcon)`
    width: 16px;
    height: 16px;
    top: 11px;
    left: 25px;
`

const MobileSearchIcon = styled(SearchIcon)`
  mask-image: url(${magnifyingGlassImageMobile});
  width: 24px;
  height: 24px;
  right: 0;
  left: auto;
  top: 15px;
  margin-right: 20px;
  display: none;

  &:hover {
    cursor: pointer;
  }

  ${mq['SM']} {
    display: block;
    top: -12px;
  }
`

const MobileCloseIcon = styled(MobileSearchIcon)`
  mask-image: url(${closeImage});
  width: 19px;
  height: 19px;
  position: relative;
  top: 0;
  bottom: auto;
  left: auto;
  right: auto;
  margin: 0 10px 0 20px;

  ${mq['SM']} {
    top: 0;
  }
`

const DropdownCloseIcon = styled(MobileCloseIcon)`
  right: 0;
  position: absolute;
  margin: 20px;
  display: none;

  ${mq['SM']} {
    top: 0;
    display: block;
  }
`

const ArrowImage = styled.span`
  mask-image: url(${arrowImage});
  background-color: ${colorGray80};

  width: 10px;
  height: 5px;
  display: inline-block;
  margin-bottom: 2px;
  margin-left: 4px;

  &:hover {
    background-color: ${colorPine80};
  }

  ${mq['SM']} {
    display: none;
  }
`

const handleKeyDown = (e) => {
  if (e.key === 'Enter') {
    const searchTerm = e.target.value;

    window.location.assign(`/explore/${searchTerm}?src=search`);
  }
}

const MyListItem = styled(NavItem)`
  margin: 0;
  display: flex;
  flex: 0 0 auto;

  a {
    padding-right: 0;
    margin-right: 0;
    display: inline-block;
  }

  ${mq['SM']} {
    margin-right: 26px;
    flex: 1 1 0;
    justify-content: flex-end;
    padding: 10px 0;

    a {
      padding: 4px 2px;
    }

    &::after {
      content: ' |';
      color: ${colorGray60};
      font-size: 14px;
      padding-top: 4px;
      padding-left: 8px;
    }
  }

  ${xxl} {
    &:first-of-type {
      a {
      margin-left: 8px;
      padding-left: 8px;
      }
    }
  }
`

const MyList = ({onClick}) => (
    <MyListItem>
      <NavItemLink href="/" onClick={() => onClick(myList)}>{myList.label}</NavItemLink>
    </MyListItem>
)

const Dropdown = styled.div`
  position: relative;
  flex: 1;
  padding: 0;
  min-width: 108px;
  display: block;
  align-items: center;
  text-align: left;

  ${mq['SM']} {
    order: 4; // at mobile be the last flex child
    flex: 1;
    border-top: solid 1px ${colorGray20};
    position: unset;
    height: 46px;
    display: flex;
    align-items: center;
    flex-basis: 30%;
    flex-grow: 0;
    min-width: auto;
    padding: 0;
    margin: 0;
    justify-content: flex-end;
    box-sizing: content-box;
  }

  ${mq['XS']} {
    flex-basis: 40%;
  }
`

const Toggle = styled.div`
  font-size: 14px;
  padding: 0;
  margin: 0 12px 0 16px;
  font-weight: normal;
  color: ${(props) => props.isSelected ? colorGray100 : colorGray80};
  text-align: left;
  display: inline-block;

  .arrow-image {
    background-color: ${(props) => props.isSelected ? colorGray100 : colorGray80};
  }

  &:hover {
    cursor: pointer;
    color: ${(props) => props.isSelected ? colorGray100 : colorPine80};

    .arrow-image {
      background-color: ${(props) => props.isSelected ? colorGray100 : colorPine80};
    }
  }

  ${mq['SM']} {
    margin: 0 20px 0 0;
    display: inline;
    align-items: center;
    flex-shrink: 0;
    padding: 0;
  }
`

const SubNav = styled.ul`
  font-family: ${FONT_GRAPHIK};
  color: ${colorGray80};
  padding: 8px 0;
  margin: 0;
  text-align: left;

  ${mq['SM']} {
    padding: 16px 0;
  }
`

const SubNavItem = styled.li`
  list-style-type: none;
  padding: 8px 0;
  color: ${colorGray80};

  ${mq['SM']} {
    padding: 16px 20px;
  }
`

const DropdownContent = styled.div`
  background-color: #fff;
  position: absolute;
  top: 30px;
  left: 10px;
  min-width: 110px;
  border-radius: 4px;
  box-shadow: 0 3px 10px rgba(0,0,0,0.15);

  ${mq['SM']} {
    position: fixed;
    top: 94px;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    box-shadow: none;
    border-radius: 0;
    border-top: solid 1px ${colorGray20};
  }
`

const AllTopics = ({onOpenChange, menuItems, onClick}) => {
  const [isOpen, _setIsOpen] = useState(false);
  const setIsOpen = val => {
    if (isOpen === val) {
      return false;
    }

    _setIsOpen(val);
    onOpenChange(val);
  }

  useEffect(() => {
    const close = () => setIsOpen(false);

    window.addEventListener('click', close);
    return function cleanup() {
      window.removeEventListener('click', close);
    };
  });

  const onMenuClick = (event) => {
    event.stopPropagation();
    setIsOpen(!isOpen);
  }

  return (
      <Dropdown>
        <Toggle
            onClick={onMenuClick}
            isSelected={isOpen}>All Topics<ArrowImage className="arrow-image" /></Toggle>
        {isOpen &&
        <DropdownContent>
          <DropdownCloseIcon onClick={() => setIsOpen(false)}/>
          <SubNav>
            {menuItems.map((mi) => (
                <SubNavItem key={mi.label}>
                  <NavItemLink
                      href={mi.url}
                      onClick={() => onClick(mi)}>
                    {mi.label}
                  </NavItemLink>
                </SubNavItem>
            ))}
          </SubNav>
        </DropdownContent>}
      </Dropdown>
  )
}

const MobileSearchExpanded = styled.div`
  display: ${({showInput}) => showInput ? 'flex' : 'none'};
  background-color: #fff;
  height: 36px;
  width: 100%;
  top: 5px;
  left: 0;
  position: absolute;
  padding: 0 15px;
  box-sizing: border-box;
  align-items: center;
  z-index: 1;
`

export default ({selectedItem, onClick}) => {
  const [isSearchActive, setSearchActive] = useState(false);

  return (
      <ExploreContainer>
        <ExploreHeader>
          <a href="/"><PocketLogo/></a>
          <NavContainer>
            <NavList>
              {menuItems.map((mi, index) => (
                  <NavItem key={mi.label} className={`nav-item-${index} nav-item-${mi.label}`}>
                    {mi === selectedItem ?
                        <NavItemLinkSelected
                            href={mi.url}
                            onClick={() => onClick(mi)}>{mi.label}</NavItemLinkSelected>
                        : <NavItemLink href={mi.url} onClick={() => onClick(mi)}>{mi.label}</NavItemLink>
                    }
                  </NavItem>
              ))}
            </NavList>
          </NavContainer>
          <AllTopics
              onOpenChange={(isOpen) => {
                if (isOpen) {
                  document.body.classList.add('no-scroll');
                } else {
                  document.body.classList.remove('no-scroll');
                }
              }}
              menuItems={subNav}
              onClick={onClick}
          />
          <SearchContainer>
            <DesktopSearchBar showInput={isSearchActive}>
              <SearchIcon/>
              <SearchInput placeholder='Search Pocket' onKeyDown={(e) => handleKeyDown(e)}/>
            </DesktopSearchBar>
            <MobileSearchIcon onClick={() => setSearchActive(true)}/>
          </SearchContainer>
          <MobileSearchExpanded showInput={isSearchActive}>
            <SearchIconInput/>
            <MobileSearchInput placeholder='Search Pocket' onKeyDown={(e) => handleKeyDown(e)}/>
            <MobileCloseIcon onClick={() => setSearchActive(false)}/>
          </MobileSearchExpanded>
          <MyList onClick={onClick}/>
        </ExploreHeader>
      </ExploreContainer>
  )
};

